import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "mso_cart_v1";

export function CartProvider({ children }) {
  const [state, setState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || { mode: null, date: null, items: [] }; }
    catch { return { mode: null, date: null, items: [] }; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(state)); }, [state]);

  const setMode = useCallback((mode, date) => setState((s) => ({ ...s, mode, date: date ?? s.date })), []);
  const setDate = useCallback((date) => setState((s) => ({ ...s, date })), []);
  const addItem = useCallback((item) => setState((s) => ({ ...s, items: [...s.items, item] })), []);
  const removeItem = useCallback((idx) => setState((s) => ({ ...s, items: s.items.filter((_, i) => i !== idx) })), []);
  const clear = useCallback(() => setState({ mode: null, date: null, items: [] }), []);

  const subtotal = state.items.reduce((sum, it) => sum + (it.unit_price || 0), 0);

  return (
    <CartContext.Provider value={{ ...state, subtotal, setMode, setDate, addItem, removeItem, clear }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
